import React from 'react'

type AnchorProps = {
  anchor: string
  [key: string]: unknown
}
const Anchor: React.FC<AnchorProps> = ({ anchor, ...props }) => {
  return <a id={anchor} {...props} />
}
export default Anchor
